module.exports = __webpack_public_path__ + "static/img/invite.ff957171.png";